import { render, staticRenderFns } from "./AddMeasureCustom.vue?vue&type=template&id=647e80b5&"
import script from "./AddMeasureCustom.vue?vue&type=script&lang=js&"
export * from "./AddMeasureCustom.vue?vue&type=script&lang=js&"
import style0 from "./AddMeasureCustom.vue?vue&type=style&index=0&id=647e80b5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports